<template>
    <div>
        <el-tabs v-model="activeTab">
            <el-tab-pane label="用户协议" name="user">
                <Editor v-model="form.userAgreementContent" />
            </el-tab-pane>
            <el-tab-pane label="隐私协议" name="privacy">
                <Editor v-model="form.privateAgreementContent" />
            </el-tab-pane>
        </el-tabs>
        <el-button class="mt-5" type="primary" @click="handleSave">保存</el-button>
    </div>
</template>

<script>
import { detail, edit } from '@/api/content/protocol';
import Editor from "@/components/Editor.vue";
export default {
    components: { Editor },
    data() {
        return {
            activeTab: "user",
            form: {
                userAgreementContent: "",
                privateAgreementContent: ""
            }
        }
    },
    mounted() {
        detail().then(res => {
            this.form.userAgreementContent = res.result.userAgreementContent;
            this.form.privateAgreementContent = res.result.privateAgreementContent;
        })
    },
    methods: {
        handleSave() {
            edit(this.form).then(({ code, message }) => {
                if (code === 200) {
                    this.$message.success('保存成功');
                } else {
                    this.$message.error(message)
                }
            })
        }
    }
}
</script>

<style></style>